import React, { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";

import toastError from "../../../errors/toastError";
import StatusChip from "./StatusChip";
import { AttachmentIcon, formatDateBR } from "./helpers";
import { openFollowUpAttachment } from "./openProtectedFile";

const useStyles = makeStyles((theme) => ({
  list: { marginTop: theme.spacing(1), borderTop: `1px solid ${theme.palette.divider}` },
  item: { padding: theme.spacing(0.75, 0), borderBottom: `1px solid ${theme.palette.divider}` },
  head: { display: "flex", alignItems: "center", flexWrap: "wrap", gap: theme.spacing(1), fontSize: 12, color: theme.palette.text.secondary },
  text: { marginTop: theme.spacing(0.25), whiteSpace: "pre-wrap", wordBreak: "break-word" },
  attachments: { marginTop: theme.spacing(0.5), display: "flex", flexDirection: "column", gap: theme.spacing(0.5) },
  attachmentLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    cursor: "pointer",
    color: theme.palette.primary.main,
    width: "fit-content",
    "&:hover": { textDecoration: "underline" },
  },
}));

/** Lista de andamentos na ordem recebida. Texto sempre como texto puro (React escapa). */
const FollowUpList = ({ occurrenceId, followUps }) => {
  const classes = useStyles();
  const [opening, setOpening] = useState(null);

  if (!followUps || followUps.length === 0) return null;

  const open = async (followUp, attachment) => {
    const key = `${followUp.id}-${attachment.id}`;
    setOpening(key);
    try {
      await openFollowUpAttachment({
        occurrenceId,
        followUpId: followUp.id,
        attachmentId: attachment.id,
      });
    } catch (err) {
      toastError(err);
    } finally {
      setOpening(null);
    }
  };

  return (
    <div className={classes.list}>
      {followUps.map((followUp) => (
        <div key={followUp.id} className={classes.item}>
          <div className={classes.head}>
            <span>{formatDateBR(followUp.createdAt)}</span>
            {followUp.authorName ? <span>{followUp.authorName}</span> : null}
            {followUp.status ? <StatusChip status={followUp.status} /> : null}
          </div>
          {followUp.text ? (
            <Typography variant="body2" className={classes.text}>
              {followUp.text}
            </Typography>
          ) : null}
          {followUp.attachments && followUp.attachments.length > 0 ? (
            <div className={classes.attachments}>
              {followUp.attachments.map((attachment) => {
                const key = `${followUp.id}-${attachment.id}`;
                return (
                  <div
                    key={key}
                    className={classes.attachmentLink}
                    onClick={() => (opening ? undefined : open(followUp, attachment))}
                  >
                    {opening === key ? (
                      <CircularProgress size={14} />
                    ) : (
                      <AttachmentIcon mimeType={attachment.mimeType} fontSize="small" />
                    )}
                    <Typography variant="body2">{attachment.fileName}</Typography>
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default FollowUpList;
